if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // Selectors
        this.radios = this.querySelectorAll('input[type="radio"]');

        // Events
        this.radio_events = [];
        this.radios.forEach((radio) => {
          const handler = this.updateSelection.bind(this);
          radio.addEventListener('change', handler);
          this.radio_events.push({ radio, handler });
        });
        this.content_updated_handler = this.contentUpdated.bind(this);
        this.addEventListener('content-updated', this.content_updated_handler);
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.destroy();
      }

      destroy() {
        this.radio_events.forEach(({ radio, handler }) => {
          radio.removeEventListener('change', handler);
        });
        this.removeEventListener('content-updated', this.content_updated_handler);
      }

      contentUpdated() {
        this.destroy();
        this.init();
      }

      updateDisplay(activeRadio) {
        const label = activeRadio.nextElementSibling;
        const variantImgUrl = activeRadio.dataset.variantImage;
        const variantUrl = activeRadio.dataset.variantUrl;
        const badge = activeRadio.dataset.variantBadge;
        const price = label.querySelector('.tile-option-price .price');
        const productId = activeRadio.id && activeRadio.id.indexOf('-') > -1 ? activeRadio.id.split('-')[0] : null;
        let variantId = null;

        if (variantImgUrl) {
          const newImagePath = variantImgUrl.split('?')[0];
          const img = this.querySelector('.card__media .media img');

          const srcQuery = img.src.includes('?') ? '?' + img.src.split('?')[1] : '';
          img.src = `${newImagePath}${srcQuery}`;

          if (img.srcset) {
            const updatedSrcset = img.srcset
              .split(',')
              .map((set) => {
                const [urlPart, size] = set.trim().split(' ');
                const query = urlPart.split('?')[1] || '';
                return `${newImagePath}?${query} ${size}`;
              })
              .join(', ');
            img.srcset = updatedSrcset;
          }
        }

        if (variantUrl) {
          variantId = new URLSearchParams(variantUrl.split('?')[1]).get('variant');
          const targetedAttributes = ['href', 'data-product-url', 'data-url'];
          this.querySelectorAll('.variant-updated-url').forEach((el) => {
            targetedAttributes.forEach((attr) => {
              if (el.hasAttribute(attr)) {
                el.setAttribute(attr, variantUrl);
              }
            });
          });
        }

        if (price) {
          this.querySelector('.card-information .price').innerHTML = price.innerHTML;
          // Refresh regios discount on tile
          if (productId != null && variantId != null) {
            regiosCollectionPageVariantChange(productId, variantId);
          }
        }

        const badgeEl = this.querySelector('.card__content .product-badge:not(.product-badge-regios)');
        if (badge) {
          badgeEl.innerHTML = badge;
          badgeEl.classList.forEach(cls => {
            if (cls.startsWith('product-badge-')) {
              badgeEl.classList.remove(cls);
            }
          });
          badgeEl.classList.add(`product-badge-${badge.toLowerCase().replace(/\s+/g, '-')}`);
        } else {
          badgeEl.innerHTML = '';
        }
      }

      updateSelection(e) {
        const activeRadio = e.target;
        this.updateDisplay(activeRadio);
      }
    }
  );
}
